<template>
  <div class="conteudo-sistema">
    <div class="fl-cabecalho">
      <div class="row">
        <div class="col-12 form-group animated slideInDown">
          <h4>
            <fa-icon icon="cubes" />Módulos
          </h4>
        </div>
      </div>

      <div class="row animated slideInDown">
        <div class="col-lg-4 col-9 col-xs-9 form-group">
          <flFind @key-up="(inputText) => $refs.table.filtraLista(inputText)" placeholder="Buscar" />
        </div>
      </div>
    </div>

    <flCarregando style="margin-top:20px" v-if="load" />

    <fl-table
      v-show="!load"
      ref="table"
      :perPage="40"
      class="animated fadeIn fast"
      columnStartSortable="id"
      :columns="geraCabecalhos()"
    />
  </div>
</template>

<script>
import flTable from "../../../components/table/main.vue";
import flCarregando from "../../../components/carregando/main.vue";
import axios from "../../../routers/axios";
import flFind from "../../../components/find/main.vue";

export default {
  components: {
    flTable,
    flCarregando,
    flFind
  },

  data() {
    return {
      slide: "hide",
      exibir: false,
      load: false
    };
  },

  mounted() {
    this.carregaDados();
  },

  methods: {
    geraCabecalhos() {
      let columns = [];

      columns.push({
        name: "Código",
        key: "id",
        searchable: true,
        sortable: true,
        class: "",
        width: "5%"
      });

      columns.push({
        name: "Descrição",
        key: "descricao",
        searchable: true,
        sortable: true,
        class: "",
        width: "20%"
      });

      return columns;
    },

    carregaDados() {
      this.load = true;
      axios.get(this._getUrl("api/moduloSistema")).then(response => {
        this.load = false;
        let list = response.data.map(item => {
          return this.geraColunas(item);
        });

        this.$refs.table.loadTable(list);
      });
    },

    geraColunas(item) {
      let itemLista = {};
      let columns = [];

      // id
      columns.push({
        html: item.id
      });

      // descricao
      columns.push({ value: item.descricao });

      itemLista._object = item;
      itemLista.columns = columns;
      return itemLista;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adm/modulo-sistema/main.vue